import { useCallback } from 'react';
var arrowKeyArray = ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown', 'PageDown + Shift', 'PageUp + Shift'];

var isArrowKey = (code, callback) => !!(callback && arrowKeyArray.includes(code));

var selectKeyArray = ['Enter', 'Space'];

var isSelectKey = (code, callback) => !!(callback && selectKeyArray.includes(code));

var isTabKey = (code, callback) => !!(callback && code === 'Tab');

var isShiftTabKey = (code, callback) => !!(callback && code === 'Tab + Shift');

var isEscapeKey = (code, callback) => !!(callback && code === 'Escape');

var getKey = event => event.shiftKey ? "".concat(event.code, " + Shift") : event.code;
/**
 * useKeyDown - A hook that provides keyboard event handling. can be used for arrows navigation, etc.
 *
 * It accepts an optional callback functions:
 * - `handleArrowKey` that is called when an arrow key is pressed.
 * - `handleSelectKey` that is called when an `Enter` or `Space` is pressed.
 * - `handleFocus` that is called when a `Tab` is pressed.
 * - `handleBlur` that is called when a `Shift + Tab` is pressed.
 * - `handleEscape` that is called when an `Escape` is pressed.
 */


export var useKeyDown = _ref => {
  var {
    handleArrowKey,
    handleSelectKey,
    handleFocus,
    handleBlur,
    handleEscape
  } = _ref;
  var onKeyDown = useCallback(event => {
    switch (true) {
      case isArrowKey(getKey(event), handleArrowKey):
        event.preventDefault();
        handleArrowKey === null || handleArrowKey === void 0 ? void 0 : handleArrowKey(getKey(event));
        break;

      case isSelectKey(event.code, handleSelectKey):
        event.preventDefault();
        handleSelectKey === null || handleSelectKey === void 0 ? void 0 : handleSelectKey(event.code);
        break;

      case isTabKey(getKey(event), handleFocus):
        event.preventDefault();
        handleFocus === null || handleFocus === void 0 ? void 0 : handleFocus();
        break;

      case isShiftTabKey(getKey(event), handleBlur):
        event.preventDefault();
        handleBlur === null || handleBlur === void 0 ? void 0 : handleBlur();
        break;

      case isEscapeKey(event.code, handleEscape):
        event.preventDefault();
        handleEscape === null || handleEscape === void 0 ? void 0 : handleEscape();
        break;

      default:
        break;
    }
  }, [handleArrowKey, handleSelectKey, handleFocus, handleBlur, handleEscape]);
  return {
    onKeyDown
  };
};
//# sourceMappingURL=useKeyDown.js.map